import gql from 'graphql-tag'

export const ORGANISATION_GOOGLE_WALLET_QUERY = gql`
query OrganisationGoogleWalletSettings {
  organisationGoogleWalletSettings {
    result {
      id
      logo
      logoHeight
      logoWidth
    }
  }
}
`